<img
	class="icon"
	[src]="iconPath()"
	[style.width]="width"
	[style.height]="height"
/>
